<template>
  <div>
    <div class="col-lg-12 text-center mt-5 mb-2">
      <span><h2><b>Inventario {{nameMarca}}</b></h2></span>
      <div class="row">
        <!-- {{selectedAlmacen}} -->
        <div class="col-lg-2">
          <b-form-select
            v-model="selectedAlmacen"
            :options="almacenes"
            value-field="item"
            text-field="name"
            disabled-field="notEnabled"
          ></b-form-select>
        </div>
        <div class="col-lg-8 mt-4 text-center row justify-content-center" v-if="showBarcodeInput">
          <div class="col-lg-3 table-primary">
            <b>Piezas escaneadas: {{escaneadosNo}}</b>
          </div>
          <div class="col-lg-3 table-secondary">
            <b>Total escaneadas: $ {{escaneadosTotal | formatNumberCurrency}}</b>
          </div>
          <div class="col-lg-3 table-danger">
            <b>Total faltante: $ {{realVsEscaneado | formatNumberCurrency}}</b>
          </div>
        </div>
      </div>
      <div class="row justify-content-end">
        <button v-if="$can('create', 'Inventario')" type="button" class="btn" :class="{ 'btn-danger': showBarcodeInput, 'btn-info': !showBarcodeInput }" @click="fisico">{{showBarcodeInput ? 'Cancelar Invetario Fisico' : 'Realizar Invetario Fisico'}}</button>
        <jsonExcel :data="jsondata"
          class="btn btn-secondary ml-4"
          :fields= "{
            'Codigo Producto': 'barcode',
            'Cliente': 'client',
            'Producto': 'product',
            'Cantidad': 'amount',
            'Catalogo': 'catalogo',
            'Proveedor': 'provider',
          }"
          worksheet="Reporte de compra"
          name="Reporte de inventario.xls"
        >
          Descargar a Excel
        </jsonExcel>
      </div>
      <!-- {{ faltantesPending }} -->
      <div class="row justify-content-end mt-3" v-if="showBarcodeInput">
        <button type="button" class="btn btn-warning" @click="updateInventary">Actualizar inventario Actual</button>
      </div>
      <div class="row justify-content-end mt-3" v-if="showBarcodeInput && faltantes.length === 0">
        <button type="button" class="btn btn-info" @click="endInventory">Terminar</button>
      </div>
    </div>
    <div class="row justify-content-center" v-if="showBarcodeInput">
      <input ref="searchBarcode" class="inputBarCode" type="text" v-model="barcodeSearch" placeholder="Codigo de barras" min="0" v-on:keyup.enter="searchElement"/>
    </div>
    <div class="row justify-content-center mt-5">
      <div class="col-lg-3">
        <h6><b>Cantidad de piezas: {{cantidadProductos}}</b></h6>
      </div>
      <div class="col-lg-3">
        <h6><b>Cantidad de faltantes: {{cantidadFaltantes}}</b></h6>
      </div>
      <div class="col-lg-3">
        <h6><b>Total de inventario: $ {{totalVentaInventario | formatNumberCurrency}}</b></h6>
      </div>
      <div class="col-lg-3">
        <h6><b>Total de faltantes: $ {{totalFaltantes | formatNumberCurrency}}</b></h6>
      </div>
    </div>
    <template>
      <!-- {{jsondata}} -->
      <vue-good-table
      :columns="columns"
      :rows="jsondata"
      :sort-options="{
        enabled: true,
      }"
      styleClass="vgt-table bordered"
       :row-style-class="rowStyleClassFn"
      :pagination-options="{
        enabled: true,
        mode: 'registros',
        position: 'top',
        perPage: 15,
        nextLabel: 'siguiente',
        prevLabel: 'anterior',
        rowsPerPageLabel: 'Filas por página',
        ofLabel: 'de',
        pageLabel: 'páginas', // for 'pages' mode
        allLabel: 'Todos',
      }"
      >
        <template slot="table-row" slot-scope="props">
          <span v-if="props.column.field == 'config'" >
            <button @click="ShowDetail(props.row)" class="btn btn-primary">Detalle</button>
            <button v-if="showBarcodeInput && selectedAlmacen !== 'CLIENTES'" @click="selectedItem(props.row)" class="btn btn-warning">Editar</button>
          </span>
          <!-- <span v-if="props.column.field == 'config'" @click="ShowDetail(props.row)" class="btn btn-primary">
            EDITAR
          </span> -->
        </template>
      </vue-good-table>
    </template>
    <modal name="DetalleInventario" :adaptive="true" :scrollable="true" height="550" class="">
      <div class="text-right">
        <span class="close-modal" @click="$modal.hide('DetalleInventario')">
          <font-awesome-icon :icon="['fa', 'times-circle']" />
        </span>
      </div>
      <div class="text-center reset-pass">
        <h2>Detalle de inventario</h2>
        <h5>{{detailStocktaking[0].product}}</h5>
        <!-- {{itemsInventarioDetail}} -->
        <div class="mt-3 col-lg-12">
          <b-table
            show-empty
            stacked="md"
            :fixed="true"
            :borderless="true"
            :items="itemsInventarioDetail"
            :fields="fields"
            :current-page="currentPage"
            :per-page="perPage"
            :filter="filter"
            :sort-by.sync="sortBy"
            :sort-desc.sync="sortDesc"
            :sort-direction="sortDirection"
            class="table"
          >
          </b-table>
        </div>
      </div>
    </modal>
    <modal name="updatesInventary" :adaptive="true" :scrollable="true" width="1100px" height="auto" class="">
      <div class="text-right">
        <span class="close-modal" @click="$modal.hide('updatesInventary')">
          <font-awesome-icon :icon="['fa', 'times-circle']" />
        </span>
      </div>
      <div class="text-center reset-pass row justify-content-center">
        <h2>Modificar Inventario</h2>
        <!-- <h5>{{detailStocktaking[0].product}}</h5> -->
        <!-- {{itemsInventarioDetail}} -->
        <div class="mt-3 mb-4 col-lg-10">
          <b-table
            show-empty
            :fixed="true"
            :borderless="true"
            :items="faltantes"
            :fields="fields2"
            :current-page="currentPage"
            :per-page="perPage"
            :filter="filter"
            :sort-by.sync="sortBy"
            :sort-desc.sync="sortDesc"
            :sort-direction="sortDirection"
          >
            <template #cell(action)="data">
              <b-dropdown id="dropdown-1" text="Acciones" class="m-md-2">
                <b-dropdown-item @click="volverPedir(data)">
                  <font-awesome-icon :icon="['fa', 'shopping-cart']"/> Pedir de nuevo
                </b-dropdown-item>
                <b-dropdown-item @click="cancelarPedido(data)" style="background: red; color: white">
                  <font-awesome-icon :icon="['fa', 'shopping-cart']"/> Cancelar
                </b-dropdown-item>
              </b-dropdown>
            </template>
          </b-table>
        </div>
      </div>
    </modal>
    <modal name="updateItemWarestor" :adaptive="true" :scrollable="true" width="800px" height="auto" class="">
      <div class="text-right">
        <span class="close-modal" @click="$modal.hide('updateItemWarestor')">
          <font-awesome-icon :icon="['fa', 'times-circle']" />
        </span>
      </div>
      <div class="text-center reset-pass row justify-content-center">
        <h2>Modificar Inventario de producto "{{ itemSelected.product }}"</h2>
        <!-- <h5>{{detailStocktaking[0].product}}</h5> -->
        <!-- {{itemsInventarioDetail}} -->
        <div class="mt-3 mb-4 col-lg-10">
          <input type="number" name="" id="" class="form-control" v-model="itemSelected.amount_update">
          <button class="btn-success col-4 mt-4 p-4" @click="saveWarestorItem">Guardar</button>
        </div>
      </div>
    </modal>
  </div>
</template>

<script>
import { BTable, BDropdown, BDropdownItem, BFormSelect } from 'bootstrap-vue'
import { VueGoodTable } from 'vue-good-table'
import axiosAdelaService from '@/axios/axiosAdelaService'
import formatData from '@/mixins/formatAxios'
import moment from 'moment'
import { mapGetters } from 'vuex'
import JsonExcel from 'vue-json-excel'

// import { BDropdown, BDropdownItem, BFormSelect } from 'bootstrap-vue'

moment.locale('es')
// const axios = require('axios')
// var https = require('https')

export default {
  props: ['marca'],
  mixins: [formatData],
  components: {
    VueGoodTable,
    JsonExcel,
    BTable,
    BFormSelect,
    BDropdown,
    BDropdownItem
  },
  data () {
    return {
      ordersScann: [],
      barcodeSearch: '',
      showBarcodeInput: false,
      almacenes: [],
      selectedAlmacen: 'CLIENTES',
      totalFaltantes: 0,
      cantidadProductos: 0,
      cantidadFaltantes: 0,
      totalVentaInventario: 0,
      nameMarca: '',
      rows: [],
      itemsInventarioDetail: [],
      isLoading: false,
      id_provider: 0,
      jsondata: [],
      detailStocktaking: [{
        client: '',
        statusName: '',
        cantidad: '',
        date: '',
        id_client: 0
      }],
      optionsMarca: [],
      optionsEnterprise: [],
      totalRecords: 0,
      serverParams: {
        columnFilters: {},
        sort: {
          field: '',
          type: ''
        },
        page: 1,
        perPage: 10
      },
      columns: [
        {
          label: 'Codigo Producto',
          field: 'barcode',
          filterOptions: {
            placeholder: 'Codigo de barras',
            enabled: true
          }
        },
        {
          label: 'Cliente',
          field: 'client',
          filterOptions: {
            placeholder: 'Cliente',
            enabled: true
          }
        },
        {
          label: 'Producto',
          field: 'product',
          filterOptions: {
            placeholder: 'Producto',
            enabled: true
          }
        },
        {
          label: 'Cantidad',
          field: 'amount',
          filterOptions: {
            placeholder: 'Cantidad',
            enabled: true
          }
        },
        {
          label: 'Catalogo',
          field: 'catalogo',
          filterOptions: {
            placeholder: 'Catalogo',
            enabled: true
          }
        },
        {
          label: 'Proveedor',
          field: 'provider',
          filterOptions: {
            placeholder: 'Proveedor',
            enabled: true
          }
        },
        {
          label: 'Detalle',
          field: 'config'
        }
      ],
      fields: [
        // { key: 'id_client', label: 'No. cliente', sortable: true, sortDirection: 'desc' },
        { key: 'client', label: 'Cliente', sortable: true, sortDirection: 'desc' },
        { key: 'name', label: 'Movimiento', sortable: true, sortDirection: 'desc' },
        { key: 'type', label: 'Tipo', sortable: true, sortDirection: 'desc' },
        { key: 'cantidad', label: 'Cantidad', sortable: true, sortDirection: 'desc' },
        { key: 'date', label: 'Fecha', sortable: true, sortDirection: 'desc' }
      ],
      fields2: [
        // { key: 'id_client', label: 'No. cliente', sortable: true, sortDirection: 'desc' },
        { key: 'barcode', label: 'Codigo', sortable: true, sortDirection: 'desc' },
        { key: 'client', label: 'Cliente', sortable: true, sortDirection: 'desc' },
        { key: 'product', label: 'Producto', sortable: true, sortDirection: 'desc' },
        { key: 'amount', label: 'Cantidad', sortable: true, sortDirection: 'desc' },
        { key: 'catalogo', label: 'Catalogo', sortable: true, sortDirection: 'desc' },
        { key: 'provider', label: 'Proveedor', sortable: true, sortDirection: 'desc' },
        { key: 'action', label: 'Acción', sortable: true, sortDirection: 'desc' }
      ],
      currentPage: 1,
      perPage: 50,
      pageOptions: [50, 100],
      sortBy: null,
      sortDesc: false,
      sortDirection: 'asc',
      filter: null,
      faltantes: [],
      itemSelected: []
    }
  },
  computed: {
    ...mapGetters({
      user: 'getUser'
    }),
    escaneadosNo () {
      return this.ordersScann.length
    },
    escaneadosTotal () {
      let total = 0
      this.ordersScann.forEach(el => {
        total += el.total
      })
      return total
    },
    faltantesPending () {
      let total = 0
      this.jsondata.forEach(el => {
        console.log('aqui', el)
        if (el.encontrado === 1) {
          total++
        }
      })
      return total
    },
    realVsEscaneado () {
      let total = this.totalVentaInventario
      this.ordersScann.forEach(el => {
        total -= el.total
      })
      return total
    }
  },
  watch: {
    async selectedAlmacen (val) {
      this.almacenSeleccionado = this.almacenes.find(el => el.name === val)
      await this.loadItems(this.$route.params)
    }
  },
  methods: {
    async saveWarestorItem () {
      const a = []
      for (let index = 0; index < this.jsondata.length; index++) {
        const b = this.jsondata[index]
        if (parseInt(b.order_id) === parseInt(this.itemSelected.order_id)) {
          console.log('entro')
          b.encontrado = 1
          b.amount_update = this.itemSelected.amount_update
        }
        a.push(b)
      }
      this.jsondata = a
      // this.$modal.hide('updateItemWarestor')
    },
    async selectedItem (row) {
      this.itemSelected = row
      this.$modal.show('updateItemWarestor')
    },
    async cancelarPedido (data) {
      const request = {
        order_id: data.item.order_id,
        enterprise: this.user.enterprise_id,
        id_provider: data.item.id_provider,
        amount: data.item.amount
      }
      console.log(request)
      const response = await axiosAdelaService.post('/cancelOrderInventary', request)
      if (response.status === 200) {
        this.faltantes = this.faltantes.filter(el => el.order_id !== data.item.order_id)
        this.jsondata = this.jsondata.filter(el => el.order_id !== data.item.order_id)
        this.$toastedPush({
          message: 'Pedido cancelado correctamente.',
          type: 'success'
        })
      }
    },
    async volverPedir (data) {
      const request = {
        id_order: data.item.order_id,
        enterprise: this.user.enterprise_id,
        id_provider: data.item.id_provider,
        amount: data.item.amount
      }
      console.log(request)
      const response = await axiosAdelaService.post('/reapplyOrderId', request)
      if (response.status === 200) {
        this.faltantes = this.faltantes.filter(el => el.order_id !== data.item.order_id)
        this.jsondata = this.jsondata.filter(el => el.order_id !== data.item.order_id)
        this.$toastedPush({
          message: 'Se volvio a solicitar el producto con exito..',
          type: 'success'
        })
      }
    },
    updateInventary () {
      console.log('ordersScann', this.ordersScann)
      const updates = []
      this.faltantes = []
      for (const key in this.jsondata) {
        const exist = this.ordersScann.find(el => el.id_order === this.jsondata[key].order_id)
        if (exist === undefined) {
          this.faltantes.push(this.jsondata[key])
        } else {
          updates.push(this.jsondata[key])
        }
      }
      console.log('estos son los faltantes', this.faltantes)
      console.log('estos son los que hay que actualizar', updates)
      this.$modal.show('updatesInventary')
    },
    rowStyleClassFn (row) {
      let color = ''
      if (row.encontrado === 1) {
        color = 'green'
      }
      if (row.otherClient === 1) {
        color = 'otherClient'
      }
      return color
    },
    updateParams (newProps) {
      this.serverParams = Object.assign({ page: 0 }, this.serverParams, newProps)
    },
    onPageChange (params) {
      this.updateParams({ page: params.currentPage })
      // this.loadItems()
    },
    onPerPageChange (params) {
      this.updateParams({ perPage: params.currentPerPage })
      // this.loadItems()
    },
    onSortChange (params) {
      this.updateParams({
        sort: {
          type: params[0].type,
          field: params[0].field
        }
      })
      // this.loadItems()
    },
    onColumnFilter (params) {
      this.updateParams(params)
      // this.loadItems()
    },
    async loadItems (marca) {
      try {
        this.cantidadFaltantes = 0
        this.cantidadProductos = 0
        this.totalVentaInventario = 0
        this.totalFaltantes = 0
        console.log('Marca LoadsItems', marca)
        let loadItemsFunction = ''
        if (marca.marca === 'General') {
          loadItemsFunction = 'getInventarioGeneral'
        } else {
          loadItemsFunction = 'getOrders'
        }
        console.log('Inventario loadItems', marca)
        this.jsondata = []
        const params = {
          function: loadItemsFunction,
          status: 1,
          enterprise: this.user.enterprise_id,
          almacen: this.almacenSeleccionado.id
        }
        console.log('params', params)
        const response = await axiosAdelaService.post('/' + loadItemsFunction, params)
        console.log('', response)
        if (response.status === 200) {
          this.totalRecords = response.data.totalRecords
          if (this.totalRecords > 0) {
            console.log('response.data.rows', response.data.rows)
            let total = 0
            let totalFaltantes = 0
            response.data.rows.forEach(el => {
              if (el.diferencia > 0) {
                total += el.venta
                this.cantidadProductos++
              } else {
                this.cantidadFaltantes++
                totalFaltantes += el.venta
              }
              this.jsondata.push({
                barcode: el.barcode,
                product: el.producto,
                amount: el.diferencia,
                amount_update: el.diferencia,
                catalogo: el.catalogo,
                provider: el.provider,
                id_provider: el.id_provider,
                order_id: el.id_order,
                client: el.client
              })
            })
            this.totalVentaInventario = total
            this.totalFaltantes = totalFaltantes
          } else {
            this.$toastedPush({
              message: `No existen mas registros para ${marca.marca}.`,
              type: 'error'
            })
            // this.$router.push({ name: 'stocktaking' })
          }
        }
      } catch (error) {
        console.log(error)
        this.showError('No se pudo obtener el inventario general, por favor intentelo más tarde.')
      }
    },
    async ShowDetail (...args) {
      this.detailStocktaking = args
      await this.detalleInventario(args[0])
      this.$modal.show('DetalleInventario')
    },
    async detalleInventario (args) {
      try {
        this.itemsInventarioDetail = []
        const params = {
          order_id: args.order_id,
          enterpise: this.user.enterprise_id,
          type: args.catalogo === 'S/C ALMACEN' ? 'almacen' : 'cliente'
        }
        const response = await axiosAdelaService.post('/detailInventoryByOrderId', params)
        console.log('response.data.rows', response)
        if (response.status === 200) {
          this.totalRecords = response.data.totalRecords
          if (this.totalRecords > 0) {
            response.data.rows.forEach(el => {
              this.itemsInventarioDetail.push({
                client: el.fullname,
                name: el.name,
                cantidad: el.entrada > el.salida ? el.entrada : el.salida,
                date: moment(el.date).format('YYYY-MM-DD'),
                id_client: el.id_client,
                type: el.entrada === 1 ? 'ENTRADA' : 'SALIDA'
              })
            })
          // } else {
          //   this.$toastedPush({
          //     message: 'No existen mas registros para este inventario',
          //     type: 'error'
          //   })
          //   // this.$router.push({ name: 'stocktaking' })
          }
        }
      } catch (error) {
        console.log(error)
        this.showError('No se pudo obtener el inventario, por favor intentelo más tarde.')
      }
    },
    async getAlmacenes () {
      try {
        const request = {
          data: this.user.enterprise_id
        }
        const orders = await axiosAdelaService.post('/getAlmacenes', request)
        console.log('getAlmacenes', orders)
        if (orders.status === 200) {
          this.almacenes = []
          orders.data.rows.forEach(el => {
            this.almacenes.push({ item: el.name, name: el.name, id: el.id })
          })
        }
      } catch (error) {
        this.showError('No se pudieron obtener los datos intentalo mas tarde.')
      }
    },
    async endInventory () {
      if (this.selectedAlmacen !== 'CLIENTES') {
        const request = {
          data: this.jsondata,
          enterpise: this.user.enterprise_id
        }
        await axiosAdelaService.post('/updateInventory', request)
      }
      await this.fisico()
    },
    async fisico () {
      this.showBarcodeInput = !this.showBarcodeInput
      if (!this.showBarcodeInput) {
        this.ordersScann = []
      }
      await this.loadItems(this.$route.params)
    },
    async searchElement () {
      const request = {
        barcode: this.barcodeSearch,
        enterprise: this.user.enterprise_id
      }
      const response = await axiosAdelaService.post('/getOrderByBarcode', request)
      console.log('getOrderByBarcode', response)
      if (response.status === 200) {
        const a = []
        const data = response.data.rows[0]
        const exist = this.ordersScann.find(el => el.id_order === data.id_order)
        if (exist === undefined) {
          this.ordersScann.push(data)
          for (let index = 0; index < this.jsondata.length; index++) {
            const b = this.jsondata[index]
            if (parseInt(b.order_id) === parseInt(data.id_order)) {
              b.encontrado = 1
            }
            a.push(b)
          }
          this.jsondata = a
        } else {
          this.$toastedPush({
            message: 'Este producto ya fue registrado, verifique sus datos..',
            type: 'error'
          })
        }
      }
      this.barcodeSearch = ''
    }
  },
  async mounted () {
    this.almacenSeleccionado = { id: 1 }
    await this.loadItems(this.$route.params)
    await this.getAlmacenes()
    this.nameMarca = this.$route.params.marca
    this.id_provider = this.$route.params.id_provider === undefined ? this.$route.params.id_provider : 0
  }
}
</script>

<style>
.btnGenerateBuy {
  display: inline-block;
}
.table {
  margin: auto;
  border-collapse: collapse;
  border: 1px solid #fff; /*for older IE*/
  border-style: hidden;
  font-size: 10px;
}
.table caption {
  background-color: #f79646;
  color: #fff;
  font-size: x-large;
  font-weight: bold;
  letter-spacing: .1em;
}
.table thead th {
  padding: 2px;
  background-color: #fde9d9;
  font-size: large;
}
.table thead th#thDay {
  width: 10%;
}
.table thead th#thRegular, .table thead th#thOvertime, .table thead th#thTotal {
  width: 10%;
}
.table th, .table td {
  padding: 1px;
  border-width: 1px;
  border-style: solid;
  border-color: #f79646 #ccc;
}
.table td {
  text-align: center;
}
.table tbody th {
  text-align: center;
  font-weight: normal;
}
.table tfoot {
  font-weight: bold;
  font-size: large;
  background-color: #687886;
  color: #fff;
}
.table tr.even {
  background-color: #fde9d9;
}
.green {
  background:#1580002e;
  color:white;
}
</style>
